/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import { post, CashRequestOptions } from '@cash-web/shared-util-fetch'
import {GetAccountSettingsRequest} from '@cash-web/protos/squareup/cash/janus/api/AccountSettings.pb'
import {GetAccountSettingsResponse} from '@cash-web/protos/squareup/cash/janus/api/AccountSettings.pb'


export const getAccountSettings = (request:GetAccountSettingsRequest, options?: CashRequestOptions) => post<GetAccountSettingsRequest, GetAccountSettingsResponse>("/cash-app/security/1.0/get-account-settings", request, {...options, rejectOnError: true })